import { render, staticRenderFns } from "./OperationHistoryTable.vue?vue&type=template&id=bb274b3c"
import script from "./OperationHistoryTable.vue?vue&type=script&lang=ts"
export * from "./OperationHistoryTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports